/**
 * axios配置
 */
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
// import store from "../store";
import $store from "@/store";

Vue.use(VueAxios, axios);

// 设置统一的url
(axios.defaults.baseURL =
  process.env.NODE_ENV === "production" ? process.env.VUE_APP_BASE_API : "/"), // api 的 base_url
  /* 请求拦截器 */
  axios.interceptors.request.use(
    (config) => {
      // 添加token到header
      const token = $store.state.app.token;
      if (token) {
        console.log("请求token", token);
        config.headers["token"] = token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

/* 响应拦截器 */
axios.interceptors.response.use(
  (response) => {
    const { success, message, code } = response.data;
    if (code === 200 || success === true) {
      return response.data;
    } else {
      // 响应数据为二进制流处理(Excel导出)
      if (response.data instanceof ArrayBuffer) {
        return response;
      }
      // this.$message.error(msg ||'系统出错');
      return Promise.reject(new Error(message || "Error"));
    }
  },
  (error) => {
    const { msg } = error.response.data;
    return Promise.reject(new Error(msg || "Error"));
  }
);
